import { SetInvestmentPageDateAction, SET_INVESTMENT_PAGE_DATE } from './types'

export const setInvestmentPageDateAction = (payload?: string): SetInvestmentPageDateAction => ({
  type: SET_INVESTMENT_PAGE_DATE,
  payload: payload || ''
})
